const autoNgTemplateLoaderTemplate1 = require('./storidgeClusterEventsDatatable.html');

angular.module('shbdeployer.integrations.storidge').component('storidgeClusterEventsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
  },
});
